export const BUSINESS = {
  name: "Julisa's House Cleaning",
  phone: "913-244-6114",
  phoneHref: "tel:+19132446114",
  email: "julisasprofessionalcleaning@gmail.com",
  emailHref: "mailto:julisasprofessionalcleaning@gmail.com",
  facebook: "https://www.facebook.com/profile.php?id=61586567586592",
};

export const SERVICES = [
  { slug: "residential-cleaning", icon: "Home", title: "Residential Cleaning", blurb: "Regular, dependable cleaning for houses of every size — kitchens, baths, living areas and bedrooms left fresh and organized." },
  { slug: "deep-cleaning", icon: "Sparkles", title: "Deep Cleaning", blurb: "A detailed top-to-bottom clean that reaches the spots routine visits miss, ideal for a seasonal refresh or first visit." },
  { slug: "recurring-cleaning", icon: "CalendarCheck", title: "Recurring Cleaning", blurb: "Weekly, bi-weekly, or monthly visits that keep your home consistently clean without you having to think about it." },
  { slug: "move-in-cleaning", icon: "KeyRound", title: "Move-In Cleaning", blurb: "Start fresh in your new place with a thorough clean before the boxes and furniture arrive." },
  { slug: "move-out-cleaning", icon: "Truck", title: "Move-Out Cleaning", blurb: "Leave your old home or apartment in great shape — a careful clean that helps make moving day less stressful." },
  { slug: "post-construction-cleanup", icon: "HardHat", title: "Post-Construction Cleanup", blurb: "Renovation or new build? We handle construction site cleanups — dust, debris, and residue removed so the space is ready to enjoy." },
  { slug: "apartment-cleaning", icon: "Building", title: "Apartment Cleaning", blurb: "Efficient, detailed cleaning sized for apartments, condos, and townhomes across the Kansas City metro." },
  { slug: "office-cleaning", icon: "Briefcase", title: "Office Cleaning", blurb: "A clean, organized workspace makes a difference. We keep offices tidy, fresh, and welcoming for your team and clients." },
  { slug: "commercial-cleaning", icon: "Building2", title: "Commercial Cleaning", blurb: "Professional cleaning for local businesses and commercial spaces, built around your schedule and your space." },
  { slug: "kitchen-cleaning", icon: "ChefHat", title: "Kitchen Cleaning", blurb: "Counters, sinks, appliance exteriors, cabinet fronts, and floors — the heart of your home gets special attention." },
  { slug: "bathroom-cleaning", icon: "Bath", title: "Bathroom Cleaning", blurb: "Tubs, showers, tile, toilets, mirrors, and fixtures scrubbed and detailed so the whole room feels fresh." },
  { slug: "dusting-surface-cleaning", icon: "Feather", title: "Dusting & Surface Cleaning", blurb: "Shelves, sills, baseboards, furniture, and surfaces carefully dusted and wiped down throughout your space." },
  { slug: "floor-cleaning", icon: "Layers", title: "Floor Cleaning", blurb: "Vacuuming and mopping for carpet, hardwood, tile, and laminate — clean floors that pull the whole room together." },
];

export const AREAS = [
  {
    city: "Overland Park",
    state: "KS",
    slug: "overland-park",
    blurb: "From busy family homes to home offices, we provide dependable house cleaning in Overland Park, KS that fits around your week — one-time, deep, or recurring visits.",
  },
  {
    city: "Lenexa",
    state: "KS",
    slug: "lenexa",
    blurb: "Lenexa is growing fast, and so is the to-do list at home. Our cleaning services in Lenexa, KS keep newer builds, townhomes, and established neighborhoods looking their best.",
  },
  {
    city: "Olathe",
    state: "KS",
    slug: "olathe",
    blurb: "Families in Olathe trust a clean home to make life run smoother. We bring careful, punctual cleaning services to Olathe, KS homes and apartments of every size.",
  },
  {
    city: "Kansas City",
    state: "KS",
    slug: "kansas-city-ks",
    blurb: "As a local cleaning company in Kansas City, KS, we serve homes, apartments, and small businesses across KCK with the same attention to detail on every visit.",
  },
  {
    city: "Kansas City",
    state: "MO",
    slug: "kansas-city-mo",
    blurb: "Across the state line, our cleaning company serves Kansas City, MO — from downtown apartments and condos to offices and commercial spaces throughout the metro.",
  },
];

export const WHY_US = [
  { icon: "BadgeCheck", title: "Professional Service", blurb: "We take pride in providing dependable cleaning services with attention to detail." },
  { icon: "Clock", title: "Reliable & Punctual", blurb: "We respect our customers' time and strive to provide dependable service, visit after visit." },
  { icon: "ScanSearch", title: "Attention to Detail", blurb: "We focus on the details that help make a space feel truly clean and organized." },
  { icon: "Building2", title: "Homes & Businesses", blurb: "Cleaning solutions for both residential and commercial spaces across the metro." },
  { icon: "MapPin", title: "Local Service", blurb: "Proudly serving customers throughout the Kansas City metropolitan area." },
];

export const MARQUEE_ITEMS = [
  "Overland Park, KS",
  "Lenexa, KS",
  "Olathe, KS",
  "Kansas City, KS",
  "Kansas City, MO",
  "Homes & Businesses",
  "Free Quotes",
  "Detail-Focused Cleaning",
];

export const WORK = [
  {
    src: "/images/work-renovation.jpg",
    title: "Post-Renovation Reset",
    text: "Construction dust, debris, and buildup cleared from floors, shelves, and surfaces until the room felt brand new.",
    alt: "Before and after post-renovation cleaning by Julisa's House Cleaning in Kansas City",
    tall: true,
  },
  {
    src: "/images/work-bathroom.jpg",
    title: "Bathroom Deep Clean",
    text: "Toilet and shower pan scrubbed back to bright — stains, rings, and buildup lifted away.",
    alt: "Before and after bathroom deep cleaning by Julisa's House Cleaning in Overland Park KS",
  },
  {
    src: "/images/work-living-room.jpg",
    title: "Living Room Refresh",
    text: "Carpets vacuumed, surfaces dusted, and every corner tidied — a cozy family space, reset and ready to enjoy.",
    alt: "A freshly cleaned and vacuumed living room by Julisa's House Cleaning in the Kansas City area",
    badge: "Fresh & Clean",
  },
  {
    src: "/images/work-oven-fridge.jpg",
    title: "Oven & Refrigerator Detail",
    text: "Grease, spills, and buildup removed — appliances left looking and feeling fresh again.",
    alt: "Before and after oven and refrigerator deep cleaning by Julisa's House Cleaning in Kansas City",
  },
  {
    src: "/images/work-stovetop.jpg",
    title: "Stovetop Transformation",
    text: "Burned-on messes lifted away, burner by burner, until the whole cooktop shines.",
    alt: "Before and after stovetop cleaning by Julisa's House Cleaning in Overland Park KS",
  },
  {
    src: "/images/work-vent.jpg",
    title: "Bathroom Vent Deep Clean",
    text: "Dust-packed vents carefully scrubbed back to bright — a detail most people forget.",
    alt: "Before and after bathroom exhaust vent cleaning by Julisa's House Cleaning",
  },
  {
    src: "/images/work-baseboards.jpg",
    title: "Baseboard Detail",
    text: "Edges and corners hand-scrubbed, because real clean shows in the details.",
    alt: "Before and after baseboard cleaning by Julisa's House Cleaning in Lenexa KS",
  },
  {
    src: "/images/work-toilet.jpg",
    title: "Toilet Bowl Restoration",
    text: "Stubborn hard-water staining removed for a fresh, like-new bowl.",
    alt: "Before and after toilet bowl cleaning by Julisa's House Cleaning in Olathe KS",
    wide: true,
  },
  {
    src: "/images/work-tub.jpg",
    title: "Bathtub & Tile Scrub",
    text: "Soap scum and grime scrubbed from the tub and tile surround until the whole shower wall shines.",
    alt: "Before and after bathtub and tile cleaning by Julisa's House Cleaning in Kansas City KS",
    wide: true,
  },
  {
    src: "/images/work-sink.jpg",
    title: "Sink & Vanity Refresh",
    text: "Stains and buildup lifted from the basin and granite counter, fixtures polished bright.",
    alt: "Before and after bathroom sink and vanity cleaning by Julisa's House Cleaning in Kansas City MO",
    wide: true,
  },
  {
    src: "/images/work-toilet-detail.jpg",
    title: "Toilet Detail Reset",
    text: "Dust, drips, and buildup removed from tank to base — every surface wiped down and sanitized.",
    alt: "Before and after detailed toilet cleaning by Julisa's House Cleaning in Lenexa KS",
    wide: true,
  },
];
